import { Breadcrumb } from 'element-ui'

const YBreadcrumb = Breadcrumb
YBreadcrumb.$depends = [Breadcrumb]
YBreadcrumb.$name = 'y-breadcrumb'
YBreadcrumb._name = 'Breadcrumb 面包屑'

export default YBreadcrumb
